import * as React from "react";
const SvgPlaceMarkerDrag = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 34,
	height: 39,
	viewBox: "0 0 34 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("circle", {
	cx: 16,
	cy: 16,
	r: 16,
	fill: "#45B6FC"
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 16.0002,
	cy: 16,
	r: 11.6364,
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.0201 38.7879L10.1591 28.6364L21.881 28.6364L16.0201 38.7879Z",
	fill: "#45B6FC"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M28.1631 23.4142C28.3511 23.3494 28.4827 23.1793 28.4984 22.9811C28.5141 22.7829 28.4109 22.5942 28.2355 22.5005L15.2355 15.5589C15.0595 15.4649 14.8444 15.4846 14.6883 15.609C14.5323 15.7334 14.4651 15.9387 14.5175 16.1313L18.3075 30.0615C18.3587 30.2497 18.5146 30.3909 18.7069 30.4233C18.8992 30.4557 19.0928 30.3733 19.2028 30.2123L21.6608 26.6144L24.6364 30.3134C24.8061 30.5243 25.1127 30.5619 25.3283 30.3983L26.8633 29.2335C26.9709 29.1519 27.0409 29.0302 27.0573 28.8961C27.0738 28.7621 27.0353 28.6271 26.9506 28.5218L23.9983 24.8518L28.1631 23.4142Z",
	fill: "white",
	stroke: "black",
	strokeLinejoin: "round"
}));
export default SvgPlaceMarkerDrag;
